import DatabaseConstants from './Global';
export class DataManagement {
  storeData(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  getData(key: string) {
    return localStorage.getItem(key);
  }

  removeData(key: string) {
    localStorage.removeItem(key);
  }

  getAllSections() {
    return localStorage.getItem(
      DatabaseConstants.DatabaseConstants.allSectionTableName
    );
  }

  getAllTasks() {
    return localStorage.getItem(
      DatabaseConstants.DatabaseConstants.allTaskTableName
    );
  }
}
